import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "Limit" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "overlay-content" }
const _hoisted_4 = { class: "slogan sofiaBold" }
const _hoisted_5 = { class: "stats-row no-animation" }
const _hoisted_6 = { class: "number" }
const _hoisted_7 = { class: "label" }

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'overLayText',
  props: {
    isActive: { type: Boolean }
  },
  setup(__props: any) {



const points = [
    { number: '20+', label: 'Years Experience' },
    { number: '1000+', label: 'Global Clients' },
    { number: '100%', label: 'Quality Control' }
] as const;

const isPreloaded = ref(true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["banner-content", { active: _ctx.isActive, preload: isPreloaded.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createStaticVNode("<h1 class=\"slogan-title no-animation\" data-v-ac6aff49><div class=\"title-line\" data-v-ac6aff49><span class=\"gradient-text\" data-v-ac6aff49>PROFESSIONAL METAL</span></div><div class=\"title-line\" data-v-ac6aff49><span class=\"gradient-text\" data-v-ac6aff49>CASTING SOLUTIONS</span></div></h1>", 1)),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(points, (item, index) => {
                return _createElementVNode("div", {
                  class: "stat-card",
                  key: index
                }, [
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "stat-icon" }, null, -1)),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.number), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.label), 1)
                ])
              }), 64))
            ]),
            _cache[2] || (_cache[2] = _createStaticVNode("<p class=\"description\" data-v-ac6aff49> Specializing in Investment Casting, Die Casting and Sand Casting with advanced equipment and strict quality control. </p><div class=\"cta-buttons\" data-v-ac6aff49><a href=\"/contact-us\" class=\"primary-btn\" data-v-ac6aff49> Get Quote <span class=\"btn-icon\" data-v-ac6aff49>→</span></a><a href=\"/case-studies\" class=\"secondary-btn\" data-v-ac6aff49> View Products <span class=\"btn-icon\" data-v-ac6aff49>→</span></a></div>", 2))
          ])
        ])
      ])
    ])
  ], 2))
}
}

})